import { MESApiService, type spParameter } from "@dexteel/mesf-core";
import { get } from "lodash-es";
import type {
	ProductSizeOption,
	StraightenerKpiRow,
} from "../models/StraightenerKpis";

export interface GetStraightenerKpisParams {
	start: string;
	end: string;
	productSizeId: number | null;
	crewId: string | null;
	productionShift: string | null;
	signal?: AbortSignal;
}

export const getStraightenerKpis = async ({
	start,
	end,
	productSizeId,
	crewId,
	productionShift,
	signal,
}: GetStraightenerKpisParams): Promise<StraightenerKpiRow[]> => {
	const apiService = new MESApiService();
	// Plain dates: the fact table files each group under a production date, and the
	// procedure compares dates to dates without converting either side.
	const parameters: spParameter[] = [
		{ name: "Start", value: start },
		{ name: "End", value: end },
		{ name: "ProductSizeId", value: productSizeId },
		{ name: "CrewId", value: crewId },
		{ name: "ProductionShift", value: productionShift },
	];

	const resp = await apiService.callV2(
		"[MILL].[GetStraightenerReport]",
		parameters,
		signal,
	);

	if (!resp.ok) {
		throw new Error(resp.message || "Error fetching straightener KPIs");
	}
	return get(resp, "data.tables[0].rows", []) as StraightenerKpiRow[];
};

export const getStraightenerKpisPickers = async (
	signal?: AbortSignal,
): Promise<ProductSizeOption[]> => {
	const apiService = new MESApiService();

	const resp = await apiService.callV2(
		"[MILL].[GetStraightenerReportPickers]",
		[],
		signal,
	);

	if (!resp.ok) {
		throw new Error(resp.message || "Error fetching product sizes");
	}
	return get(resp, "data.tables[0].rows", []) as ProductSizeOption[];
};
